import { render, staticRenderFns } from "./liveClassParameter.vue?vue&type=template&id=32852a0e"
import script from "./liveClassParameter.vue?vue&type=script&lang=js"
export * from "./liveClassParameter.vue?vue&type=script&lang=js"
import style1 from "./liveClassParameter.vue?vue&type=style&index=1&id=32852a0e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports